import { Injectable, Signal, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageCode } from 'app/statics/language-config';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private storageKey = 'user-language';
  private defaultLanguage: LanguageCode = LanguageCode.DE;

  private currentLanguageSignal = signal<LanguageCode>(this.getStoredLanguage() || this.defaultLanguage);

  constructor(private translate: TranslateService) {
    this.initializeLanguage();
  }

  private initializeLanguage() {
    const storedLang = this.getStoredLanguage() || this.defaultLanguage;
    this.translate.use(storedLang);
    this.currentLanguageSignal.set(storedLang);
  }

  private getStoredLanguage(): LanguageCode | null {
    return sessionStorage.getItem(this.storageKey) as LanguageCode;
  }

  changeLanguage(lang: LanguageCode): void {
    this.translate.use(lang);
    sessionStorage.setItem(this.storageKey, lang);
    this.currentLanguageSignal.set(lang);
  }

  getCurrentLanguage(): Signal<LanguageCode> {
    return this.currentLanguageSignal;
  }

  translateInstant(key: string, params?: Record<string, any>): string {
    return this.translate.instant(key, params);
  }
}
